import { FC, ReactNode } from 'react';

export interface ContainerLayoutProps {
  children?: ReactNode;
  size?: string;
  gutter?: string;
  className?: string;
}

const ContainerLayout: FC<ContainerLayoutProps> = ({
  children,
  size = 'base',
  gutter = 'base',
  className,
  ...props
}) => {
  let containerSizes;
  switch (size) {
    case 'base':
      containerSizes = 'max-w-7xl';
      break;
    case 'tighter':
      containerSizes = 'max-w-6xl';
      break;
    case 'tightest':
      containerSizes = 'max-w-5xl';
      break;
    case 'wide':
      containerSizes = 'max-w-9xl';
      break;
    case 'wider':
      containerSizes = 'max-w-10xl';
      break;
    case 'widest':
      containerSizes = 'max-w-11xl';
      break;
    case 'prose':
      containerSizes = 'max-w-prose';
      break;
    case 'full':
      containerSizes = '';
      break;
    default:
      containerSizes = 'max-w-8xl';
  }

  let containerGutters;
  switch (gutter) {
    case 'base':
      containerGutters =
        'mx-auto px-4 sm:px-6 md:px-8 lg:px-10 xl:px-16 2xl:px-20 3xl:px-24';
      break;
    case 'tight':
      containerGutters = 'px-4 sm:px-6 md:px-6 lg:px-6 xl:px-12';
      break;
    case 'tighter':
      containerGutters = 'px-4';
      break;
    case 'flush-right':
      containerGutters = 'px-4 md:pr-0 pl-4 md:pl-12 lg:pl-16 xl:pl-24';
      break;
    case 'none':
      containerGutters = 'mx-auto';
      break;
    default:
      containerGutters = '';
  }

  return (
    <div
      className={`w-full ${containerSizes} ${containerGutters} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default ContainerLayout;
